import { render, staticRenderFns } from "./template.html?vue&type=template&id=600a60d8&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./style.scss?vue&type=style&index=0&id=600a60d8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "600a60d8",
  null
  
)

export default component.exports